/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { useDispatch } from "react-redux";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import {
  PURCHASE_STATUS_CHANGE,
  PURCHASE_STOCK_LIST,
} from "../../../repository/taskRepo";

const usePurchaseStock = () => {
  const navigate = useNavigate();
  const [spinner, setSpinner] = useState(false);
  const [controller, setController] = useState({ page: 1, rowsPerPage: 10 });
  const [totalCount, setTotalCount] = useState(0);
  const [purchaseStockList, setPurchaseStockList] = useState([]);

  const { InventoryD_Id } = useParams();
  const location = useLocation();

  const handlePagination = (obj) => {
    setController(obj);
  };

  useEffect(() => {
    purchaseStockListAPI();
  }, [controller.page, controller.rowsPerPage]);

  const purchaseStockListAPI = async () => {
    try {
      let payload = {
        count: controller.rowsPerPage,
        page: controller.page,
        isDeleted: false,
        inventory_id: InventoryD_Id,
      };

      setSpinner(true);
      let response = await PURCHASE_STOCK_LIST(payload);
      setPurchaseStockList(response?.data);
      setTotalCount(response?.totalCount || 0);
    } catch (error) {}
    setSpinner(false);
  };

  const purchaseStatusChange = async (id, status) => {
    try {
      const payload = { _id: id, status };
      setSpinner(true);

      const response = await PURCHASE_STATUS_CHANGE(payload);
      if (response.code === 200) {
        toast.success(
          response.message || `Status changed to ${status} successfully`
        );
        // refresh list to reflect status change
        purchaseStockListAPI();
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update status");
    } finally {
      setSpinner(false);
    }
  };

  return {
    data: {
      spinner,
      controller,
      totalCount,
      purchaseStockList,
    },
    methods: {
      handlePagination,
      purchaseStatusChange,
    },
  };
};

export default usePurchaseStock;
